import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { updateFormState } from '../actions';
import OperatorsSelect from './OperatorsSelect';
import EstablishmentsSelect from './EstablishmentsSelect';
import PortalUsersSelect from './PortalUsersSelect';
import StatusSelect from './StatusSelect';


class FormBody extends React.Component {

    constructor(props) {
        super(props);
        this.handleResetClick = this.handleResetClick.bind(this);
        this.handleSubmitClick = this.handleSubmitClick.bind(this);
    }

    handleResetClick() {
        const { form } = this.props;
        form.reset();
        form.initialize({});
    }

    handleSubmitClick() {
        document.getElementById('orders-filters').dispatchEvent(
            new Event('submit', {
                cancelable: true
            })
        )
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div className="card-body">
                <form id="orders-filters" onSubmit={handleSubmit}>
                    <div className="row input-daterange datepicker flex-sm-column flex-md-row">
                        <div className="col-md-3 col-sm-12">
                            <div className="form-group">
                                <label className="form-control-label">Período</label>
                                <div className="input-group input-group-alternative">
                                    <Field
                                        className="form-control"
                                        name="startDate"
                                        component="input"
                                        type="date"
                                    />
                                    <Field
                                        className="form-control"
                                        name="endDate"
                                        component="input"
                                        type="date"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-12">
                            <div className="form-group">
                                <label className="form-control-label">Operadores</label>
                                <OperatorsSelect />
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-12">
                            <div className="form-group">
                                <label className="form-control-label">Estabelecimento</label>
                                <EstablishmentsSelect />
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-12">
                            <div className="form-group">
                                <label className="form-control-label">Vendedores</label>
                                <PortalUsersSelect />
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-12">
                            <div className="form-group">
                                <label className="form-control-label">Status</label>
                                <StatusSelect />
                            </div>
                        </div>

                    </div>
                    <div>
                        <button type="submit" className="btn btn-success my-4">Aplicar</button>
                        <button type="button" onClick={this.handleResetClick} className="btn btn-danger my-4">Limpar</button>
                    </div>
                </form>
            </div>
        );
    }
}

function OrdersFilterForm({ initialValues, updateFormState }) {
    return (
        <Form
            onSubmit={(values) => {
                updateFormState(values)
            }}
            initialValues={initialValues}
            render={(props) => ( <FormBody {...props} />)}
        />
    );
}

const mapsStateToProps = (state) => ({
    initialValues: state.commissions.filters
});

const mapDispatchToProps = {
    updateFormState
};

export default connect(mapsStateToProps, mapDispatchToProps)(OrdersFilterForm);



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Filters/index.js